import React, { useState, useEffect } from 'react';
import { stadiaAPI } from '../../services/api';

const StadiaSettings = () => {
  const [stadia, setStadia] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editingStadium, setEditingStadium] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    published: true
  });

  useEffect(() => {
    fetchStadia();
  }, []);

  const fetchStadia = async () => {
    try {
      const response = await stadiaAPI.getAll();
      setStadia(response.data);
    } catch (err) {
      setError('Failed to fetch stadia');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingStadium) {
        await stadiaAPI.update(editingStadium._id, formData);
      } else {
        await stadiaAPI.create(formData);
      }
      fetchStadia();
      resetForm();
    } catch (err) {
      setError('Failed to save stadium');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this stadium?')) {
      try {
        await stadiaAPI.delete(id);
        fetchStadia();
      } catch (err) {
        setError('Failed to delete stadium');
      }
    }
  };

  const resetForm = () => {
    setFormData({ name: '', published: true });
    setEditingStadium(null);
    setShowModal(false);
  };

  const handleEdit = (stadium) => {
    setFormData({
      name: stadium.name,
      published: stadium.published
    });
    setEditingStadium(stadium);
    setShowModal(true);
  };

  if (loading) return <div className="loading loading-spinner loading-lg"></div>;

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold">Stadia</h2>
        <button 
          className="btn btn-primary"
          onClick={() => setShowModal(true)}
        >
          Add Stadium
        </button>
      </div>

      {error && (
        <div className="alert alert-error">
          <span>{error}</span>
        </div>
      )}

      <div className="overflow-x-auto">
        <table className="table table-zebra w-full">
          <thead>
            <tr>
              <th>Name</th>
              <th>Team</th>
              <th>Status</th>
              <th>Created</th>
              <th>Actions</th>
            </tr>
          </thead>          <tbody>
            {Array.isArray(stadia) && stadia.map((stadium) => (
              <tr key={stadium._id}>
                <td>{stadium.name}</td>
                <td>
                  {stadium.tid ? (
                    <div className="badge badge-outline">
                      {stadium.tid.name || 'Team Assigned'}
                    </div>
                  ) : (
                    <span className="text-gray-500">No team</span>
                  )}
                </td>
                <td>
                  <div className={`badge ${stadium.published ? 'badge-success' : 'badge-error'}`}>
                    {stadium.published ? 'Published' : 'Draft'}
                  </div>
                </td>
                <td>{new Date(stadium.createdAt).toLocaleDateString()}</td>
                <td>
                  <div className="space-x-2">
                    <button 
                      className="btn btn-sm btn-outline"
                      onClick={() => handleEdit(stadium)}
                    >
                      Edit
                    </button>
                    <button 
                      className="btn btn-sm btn-error"
                      onClick={() => handleDelete(stadium._id)}
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      {showModal && (
        <dialog open className="modal">
          <div className="modal-box">
            <h3 className="font-bold text-lg">
              {editingStadium ? 'Edit Stadium' : 'Add New Stadium'}
            </h3>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="form-control">
                <label className="label">
                  <span className="label-text">Name</span>
                </label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  className="input input-bordered"
                  required
                />
              </div>
              <div className="form-control">
                <label className="label cursor-pointer">
                  <span className="label-text">Published</span>
                  <input
                    type="checkbox"
                    checked={formData.published}
                    onChange={(e) => setFormData({...formData, published: e.target.checked})}
                    className="checkbox"
                  />
                </label>
              </div>
              <div className="modal-action">
                <button type="submit" className="btn btn-primary">
                  {editingStadium ? 'Update' : 'Create'}
                </button>
                <button type="button" className="btn" onClick={resetForm}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </dialog>
      )}
    </div>
  );
};

export default StadiaSettings;
